import { useIncorporationWizardFormCtx } from "../../hooks/IncorporationWizardFormContext";
import chevronLeftIcon from "@assets/icons/chevron_left.svg?raw&inline";

export default function BackButton({ label = "Back" }: { label?: string }) {
  const { canBack, back } = useIncorporationWizardFormCtx();
  const handleBack = () => {
    if (canBack) {
      back();
    }
  };
  return (
    <button
      disabled={!canBack}
      className="btn font-weight-400 size-12 cursor-pointer d-flex align-items-center"
      style={{
        border: "none",
        boxShadow: "none",
        outline: "none",
        ...(!canBack && {
          pointerEvents: "none",
          background: "none",
          color: "#aaa",
        }),
      }}
      onClick={handleBack}
    >
      <span
        className="d-flex align-items-center"
        dangerouslySetInnerHTML={{ __html: chevronLeftIcon }}
      />
      {label}
    </button>
  );
}